<main class="content-container" [ngClass]="infiniteScrollSelector" (scroll)="onScroll($event)" #mainContent>
  <ng-content></ng-content>
</main>
